package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_06_23_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-06-23")
@Composable
public fun Log_2023_06_23(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Yuan-ti Ambush",
        ogTitle = "Yuan-ti Ambush",
        date = LocalDate(2_023, 6, 23),
        ogDescription = "In the dark caverns, the heroes battle powerful Yuan-ti serpent-folk, including a Pitmaster and an Anathema.",
        ogImage = "ai/2023-06-23.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
        Log_2023_06_23_Day_1()
    }
}
